/* SENFINECO: confirmed AJAX adds with feedback, never automatic cart navigation.
   Owns only the theme's standard add forms. Checkout and bundle flows are untouched. */
(() => {
  'use strict';
  if (window.SenfinecoStayCart || !window.fetch || !window.FormData) return;
  const ar = /^ar/i.test(document.documentElement.lang || '');
  const say = (a, e) => ar ? a : e;
  const forms = 'product-form form,form[data-type="add-to-cart-form"],form[data-sf-grid-cart],form[data-sf26-best-add]';
  const jobs = new WeakMap(), visuals = new WeakMap();
  let queue = Promise.resolve(), toast = null, toastTimer = 0, measureFrame = 0;
  let surfaceStale = false, cartRevision = 0;
  const rootPath = window.Shopify?.routes?.root || '/';
  function localRoute(value, fallback) {
    try { const u = new URL(value || fallback, location.origin); if (u.origin === location.origin && /^https?:$/.test(u.protocol)) return u; } catch (_) {}
    return new URL(fallback, location.origin);
  }
  const cartURL = () => {
    const u = localRoute(window.routes?.cart_url, rootPath + 'cart');
    const here = new URL(location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(k => { if (here.searchParams.has(k)) u.searchParams.set(k, here.searchParams.get(k)); });
    return u.pathname + u.search;
  };
  const endpoint = suffix => localRoute(rootPath + 'cart' + suffix, '/cart' + suffix).href;
  function owns(form) {
    if (!(form instanceof HTMLFormElement) || !form.matches(forms)) return false;
    if (form.closest('bundle-products,[data-sf-oil-finder]') || form.hasAttribute('data-sf26-native-add')) return false;
    try {
      const u = new URL(form.action, location.href);
      return u.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(u.pathname);
    } catch (_) { return false; }
  }
  function purchaseControl(button) {
    return button?.matches('[name="checkout"],[name="buy_now"],[data-buy-now],.shopify-payment-button__button') || button?.closest('.shopify-payment-button,shopify-accelerated-checkout');
  }
  function flash(button, form, mode) {
    if (!button?.isConnected) return;
    const old = visuals.get(button);
    if (old) { clearTimeout(old.timer); old.overlay.remove(); }
    button.classList.remove('sf26-add-busy', 'sf26-add-success');
    if (mode === 'clear') {
      if (old?.loadingAdded) button.classList.remove('loading');
      button.removeAttribute('aria-busy'); visuals.delete(button); return;
    }
    const loadingAdded = old?.loadingAdded ?? !button.classList.contains('loading');
    const overlay = document.createElement('span');
    overlay.className = 'sf26-add-feedback'; overlay.setAttribute('aria-hidden', 'true');
    const iconOnly = form?.matches('form[data-sf-grid-cart],form[data-sf26-best-add]') || button.matches('[data-sf-predictive-cart]');
    overlay.textContent = mode === 'busy' ? (iconOnly ? '…' : say('جارٍ الإضافة…', 'Adding…')) : (iconOnly ? '✓' : say('✓ تمت الإضافة', '✓ Added'));
    button.append(overlay); button.classList.add(mode === 'busy' ? 'sf26-add-busy' : 'sf26-add-success');
    button.classList.toggle('loading', mode === 'busy');
    if (mode === 'busy') button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
    const state = { overlay, loadingAdded, timer: 0 };
    if (mode === 'success') state.timer = setTimeout(() => { if (visuals.get(button) === state) flash(button, form, 'clear'); }, 1800);
    visuals.set(button, state);
  }
  function inlineError(form, message) {
    const wrapper = form?.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const copy = wrapper?.querySelector('.product-form__error-message');
    if (copy) copy.textContent = message;
    if (wrapper) wrapper.hidden = !message;
    const shelf = form?.closest('sf-bestsellers');
    const status = shelf?.querySelector('[data-sf26-best-message]');
    if (status) { status.textContent = ''; status.hidden = true; }
  }
  function ensureToast() {
    if (toast) return toast;
    toast = document.createElement('aside'); toast.className = 'sf26-add-toast'; toast.hidden = true;
    toast.dir = ar ? 'rtl' : 'ltr'; toast.setAttribute('aria-label', say('تحديث السلة', 'Cart update'));
    const copy = document.createElement('p'); copy.className = 'sf26-add-toast__copy';
    copy.setAttribute('role', 'status'); copy.setAttribute('aria-live', 'polite'); copy.setAttribute('aria-atomic', 'true');
    const headline = document.createElement('strong'), detail = document.createElement('span'); copy.append(headline, detail);
    const link = document.createElement('a'); link.className = 'sf26-add-toast__link'; link.href = cartURL(); link.textContent = say('عرض السلة', 'View cart');
    const close = document.createElement('button'); close.type = 'button'; close.className = 'sf26-add-toast__close'; close.textContent = '×'; close.setAttribute('aria-label', say('إغلاق التنبيه', 'Dismiss notification'));
    close.addEventListener('click', () => dismiss(true)); toast.append(copy, link, close); document.body.append(toast);
    toast.addEventListener('pointerenter', () => clearTimeout(toastTimer)); toast.addEventListener('focusin', () => clearTimeout(toastTimer));
    toast.addEventListener('pointerleave', armDismiss); toast.addEventListener('focusout', () => setTimeout(armDismiss, 0));
    return toast;
  }
  function dismiss(manual = false) {
    if (!toast || (!manual && toast.contains(document.activeElement))) return;
    toast.hidden = true; clearTimeout(toastTimer);
  }
  function armDismiss() {
    clearTimeout(toastTimer);
    if (!toast || toast.hidden || toast.dataset.kind !== 'success' || toast.contains(document.activeElement) || toast.matches(':hover')) return;
    toastTimer = setTimeout(() => dismiss(), 6500);
  }
  function positionToast() {
    measureFrame = 0; if (!toast || toast.hidden) return;
    const v = window.visualViewport;
    let inset = v && Math.abs(v.scale - 1) < .02 ? Math.max(0, innerHeight - v.height - v.offsetTop) : 0;
    document.querySelectorAll('[data-sf26-nav],sticky-cart-button.visible,#PBarNextFrameWrapper,[data-sfc-payment]').forEach(el => {
      const r = el.getBoundingClientRect(), s = getComputedStyle(el);
      if (r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) > .01 && ['fixed','sticky'].includes(s.position) && r.top > innerHeight * .4 && r.top < innerHeight) inset = Math.max(inset, innerHeight - r.top);
    });
    const next = `${Math.ceil(inset + 12)}px`;
    if (toast.style.getPropertyValue('--sf26-toast-bottom') !== next) toast.style.setProperty('--sf26-toast-bottom', next);
  }
  function measure() { if (toast && !toast.hidden && !measureFrame) measureFrame = requestAnimationFrame(positionToast); }
  function notify(kind, message, title = '') {
    const box = ensureToast(); clearTimeout(toastTimer); box.dataset.kind = kind;
    box.querySelector('strong').textContent = message; box.querySelector('.sf26-add-toast__copy>span').textContent = title;
    box.querySelector('a').href = cartURL(); box.hidden = false; positionToast(); armDismiss();
  }
  function productTitle(form, button) {
    const card = button?.closest('[data-sf-spare-parts-product],.product-card,.sf26-best-card');
    return String(form?.dataset.productTitle || card?.querySelector('h3,.product-card__heading')?.textContent || form?.closest('[id^="shopify-section-"]')?.querySelector('h1')?.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100);
  }
  async function request(url, options = {}, limit = 12000) {
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), limit);
    try {
      const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
      const data = await response.json();
      return { response, data };
    } finally { clearTimeout(timer); }
  }
  function updateCounts(cart, celebrate = false) {
    if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0) return false;
    const count = cart.item_count, copy = count > 99 ? '99+' : String(count);
    document.querySelectorAll('[data-sf26-count],[data-bottom-cart-count]').forEach(el => { el.textContent = copy; el.hidden = count === 0; });
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      const span = el.querySelector('[aria-hidden="true"]'); if (span) span.textContent = copy; el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('[data-sf-last-product-submit]').forEach(el => el.removeAttribute('data-sf-last-product-submit'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, totalPrice: cart.total_price, items: cart.items, timestamp: Date.now(), source: 'sf26-stay-cart' } }));
    if (celebrate) document.querySelectorAll('[data-sf26-app-nav="cart"],[data-sf26-cart]').forEach(el => {
      el.classList.remove('sf26-cart-received'); requestAnimationFrame(() => el.classList.add('sf26-cart-received')); setTimeout(() => el.classList.remove('sf26-cart-received'), 850);
    });
    return true;
  }
  async function refreshCounts(celebrate) {
    try {
      const { response, data } = await request(endpoint('.js'), { cache: 'no-store', headers: { Accept: 'application/json' } }, 7000);
      return response.ok && updateCounts(data, celebrate);
    } catch (_) { return false; }
  }
  async function refreshClosedDrawer() {
    const revision = cartRevision;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.classList.contains('active')) return;
    try {
      const url = localRoute(rootPath, '/'); url.searchParams.set('sections', 'cart-drawer');
      const { response, data } = await request(url.href, { cache: 'no-store', headers: { Accept: 'application/json' } }, 6000);
      if (!response.ok || typeof data['cart-drawer'] !== 'string') return;
      const parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const incoming = parsed.querySelector('#CartDrawer .drawer__inner');
      const current = drawer.querySelector('#CartDrawer .drawer__inner');
      if (!incoming || !current || drawer.classList.contains('active') || revision !== cartRevision) return;
      current.innerHTML = incoming.innerHTML;
      const fresh = parsed.querySelector('cart-drawer');
      if (fresh) drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
      drawer.initElements?.(); surfaceStale = false;
    } catch (_) { /* Adding succeeded. Surface refresh must never retry a POST or open the drawer. */ }
  }
  function validForm(form) {
    if (!form.checkValidity()) { form.reportValidity(); return false; }
    const quantity = Array.from(form.elements).find(el => el.name === 'quantity' && !el.disabled);
    if (quantity) {
      const n = Number(quantity.value), min = Number(quantity.min || quantity.dataset.min || 1), step = Number(quantity.step || 1);
      if (!Number.isInteger(n) || n < Math.max(1, min) || (quantity.max && n > Number(quantity.max)) || (step > 0 && Math.abs((n - min) / step - Math.round((n - min) / step)) > .0001)) {
        notify('error', say('تحقق من الكمية المطلوبة قبل الإضافة.', 'Check the quantity before adding.')); return false;
      }
    }
    return true;
  }
  function reportAPIError(form, data, variant) {
    const fallback = say('تعذّرت الإضافة. تحقق من الكمية وتوفر المنتج.', 'Could not add this item. Check its quantity and availability.');
    const message = typeof data?.description === 'string' ? data.description : typeof data?.message === 'string' ? data.message : fallback;
    inlineError(form, message); notify('error', message);
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: variant, errors: data.errors || data.description, message: data.message });
    } catch (_) { /* The visible error remains available without the theme event bus. */ }
  }
  function enqueue(owner, form, button, data) {
    if (jobs.has(owner)) return;
    const variant = String(data.get('id') || '').trim();
    if (!/^\d+$/.test(variant)) { notify('error', say('اختر المنتج أو الخيار أولًا.', 'Select a product option first.')); return; }
    // These are rendering/navigation controls, not line-item properties.
    ['sections', 'sections_url', 'return_to', 'checkout'].forEach(key => data.delete(key));
    const title = productTitle(form, button); inlineError(form, ''); flash(button, form, 'busy');
    const task = queue.catch(() => {}).then(async () => {
      let accepted = false;
      cartRevision++;
      try {
        const { response, data: result } = await request(endpoint('/add.js'), { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data }, 22000);
        if (!response.ok || result?.status) {
          reportAPIError(form, result, variant);
          surfaceStale = true; await refreshCounts(false); void refreshClosedDrawer(); return;
        }
        if (!result || (!result.id && !result.variant_id && !(Array.isArray(result.items) && result.items.length))) throw new Error('unconfirmed response');
        accepted = true; surfaceStale = true;
        flash(button, form, 'success'); notify('success', say('✓ تمت الإضافة إلى السلة', '✓ Added to your cart'), title);
        await refreshCounts(true); void refreshClosedDrawer();
      } catch (_) {
        if (!accepted) {
          inlineError(form, say('تعذّر تأكيد الإضافة. راجع السلة قبل المحاولة مجددًا.', 'Could not confirm the add. Check your cart before trying again.'));
          notify('error', say('تعذّر تأكيد الإضافة. راجع السلة قبل إعادة المحاولة.', 'Could not confirm the add. Check your cart before retrying.'));
          surfaceStale = true; await refreshCounts(false); void refreshClosedDrawer();
        }
      } finally {
        if (!accepted) flash(button, form, 'clear');
        jobs.delete(owner);
      }
    });
    jobs.set(owner, task); queue = task;
  }
  window.addEventListener('submit', event => {
    const form = event.target, button = event.submitter || (form instanceof HTMLFormElement ? form.querySelector('button[name="add"],button[type="submit"]') : null);
    if (!owns(form) || purchaseControl(button)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (jobs.has(form) || button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
    if (window.__triumphLastSelectEnter && Date.now() - window.__triumphLastSelectEnter < 1000 && !event.submitter) return;
    if (!validForm(form)) return;
    const data = new FormData(form);
    const item = form.matches('[data-sf-grid-cart]') ? form.closest('[data-sf-spare-parts-product]') : null;
    const selected = item?.dataset.sfProductVariantId || item?.dataset.sfVariantId;
    if (selected && /^\d+$/.test(selected)) data.set('id', selected);
    enqueue(form, form, button, data);
  }, true);
  window.addEventListener('click', event => {
    const button = event.target.closest?.('[data-sf-predictive-cart]');
    if (button) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (button.disabled || button.getAttribute('aria-disabled') === 'true' || jobs.has(button)) return;
      const variant = button.dataset.variantId || button.dataset.sfVariantId || button.dataset.sfPredictiveCart;
      const data = new FormData(); data.set('id', variant || ''); data.set('quantity', '1'); enqueue(button, null, button, data); return;
    }
    // Only an explicit cart click navigates; never show a stale drawer after a failed refresh.
    const link = event.target.closest?.('#cart-icon-bubble,[data-sf26-cart],[data-sf-mobile-cart]');
    if (link && surfaceStale && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(cartURL());
    }
  }, true);
  addEventListener('resize', measure, { passive: true }); addEventListener('scroll', measure, { passive: true });
  window.visualViewport?.addEventListener('resize', measure, { passive: true }); window.visualViewport?.addEventListener('scroll', measure, { passive: true });
  window.SenfinecoStayCart = { version: '1.0.0', owns, refreshCounts };
})();
